@if (isLoggedIn) {
  <div
    class="bg-white rounded-medium p-8 shadow-[0_4px_18px_0_rgba(0,0,0,0.17)] md:h-auto"
  >
    @if (currentStep === RequestWalkthroughSteps.SelectDate) {
      <app-request-walkthrough-select-date
        [property]="property"
        (dateSelected)="onDateSelected($event)"
        (close)="close()"
      ></app-request-walkthrough-select-date>
    } @else if (currentStep === RequestWalkthroughSteps.VerifyPhone) {
      <app-request-walkthrough-verify-phone
        (phoneVerified)="onPhoneVerified()"
        (close)="close()"
      ></app-request-walkthrough-verify-phone>
    } @else if (currentStep === RequestWalkthroughSteps.Success) {
      <app-request-walkthrough-success
        [property]="property"
        [walkthroughDate]="selectedDate"
        (close)="close()"
      ></app-request-walkthrough-success>
    }
  </div>
} @else {
  <app-requests-unauthorized
    (login)="login()"
    (signUp)="signUp()"
    (close)="close()"
    [suffix]="unauthorizedSuffix"
    [imgSrc]="'/assets/img/services.png'"
  ></app-requests-unauthorized>
}
